import { Component, OnInit } from '@angular/core';
import { LoaderService } from '@tmhcc-ng-lib/framwork/loader';
import {
  NewsFeedContentService,
  News,
  CommonContentService
} from '@tmhcc-ng-lib/content-service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'ae-news-feed',
  templateUrl: './news-feed.component.html',
  styleUrls: ['./news-feed.component.scss']
})
export class NewsFeedComponent implements OnInit {
  newsData: News;
  isDataAvailable: boolean = false;
  constructor(
    private loaderService: LoaderService,
    private newsContentService: NewsFeedContentService,
    private commonContentService: CommonContentService
  ) {
    this.loaderService.show();
  }

  ngOnInit(): void {
    this.commonContentService.setPageTitle();

    this.newsContentService.data$.subscribe(data => {
      this.loadNewsFeed(data);
    });
  }

  loadNewsFeed(data) {
    this.newsData = data;
    this.isDataAvailable = true;
    this.loaderService.hide();
  }
}
